import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`

.PageError {
  width: 100%;
}

.outer-wrapper {
  margin-bottom: 24px;
  background-size: contain;
  background-position: top;
  background-repeat: no-repeat !important;
  margin-top: 0px;
}

.inner-wrapper {
  display: flex;
  justify-content: center;
  align-items: center; 
  flex-shrink: 0;
}

.header {
  padding-top: 84px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  min-height: auto;
}

.most-popular-row {
  margin-top: 24px;
}

.error-title {
  align-self: stretch;
  color: var(--white-01-f-6-f-6-f-6, #F6F6F6);
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;

  /* Elevation Dark */
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.30), 0px 1px 3px rgba(0, 0, 0, 0.15);
  font-family: Source Sans Pro;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 16px;
}

.error-subtitle {
  align-self: stretch;

  color: var(--white-01-f-6-f-6-f-6, #F6F6F6);
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;

  /* Elevation Dark */
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.30), 0px 1px 3px rgba(0, 0, 0, 0.15);
  font-family: Source Sans Pro;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.error-page-buttons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
}

@media (min-width: 767px) { 
  .outer-wrapper {

  }
  
  .inner-wrapper {

  }
  
  .header {

  }
  
  .most-popular-row {

  }
  
  .row-title {

  }
  
  .error-title {

  }
  
  .error-subtitle {
    width: 727px;

    /* Elevation Dark */
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.30), 0px 1px 3px rgba(0, 0, 0, 0.15);
    font-family: Source Sans Pro;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  
  .error-page-buttons {

  }
}

@media (min-width: 1025px) { 
  .outer-wrapper {
    //margin-bottom: 72px;
    //height: unset;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, ${colors.baseBg});
  }
  
  .inner-wrapper {
    display: flex;
    justify-content: center;
    align-items: center; 
  }
  
  .header {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
  }
  
  .most-popular-row {
    margin-top: 48px;
  }
  
  .row-title {
    color: var(--white-01-f-6-f-6-f-6, #F6F6F6);
    font-family: Source Sans Pro;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-left: 54px;
  }
  
  .error-title {
    color: var(--white-01-f-6-f-6-f-6, ${colors.primaryText});
    font-feature-settings: 'clig' off, 'liga' off;
  
    /* Elevation Dark */
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.30), 0px 1px 3px rgba(0, 0, 0, 0.15);
    font-family: Source Sans Pro;
    font-size: 64px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 32px;
  }
  
  .error-subtitle {
    width: 727px;
    color: var(--white-01-f-6-f-6-f-6, ${colors.primaryText});
    text-align: center;
    font-feature-settings: 'clig' off, 'liga' off;
  
    /* Elevation Dark */
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.30), 0px 1px 3px rgba(0, 0, 0, 0.15);
    font-family: Source Sans Pro;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  
  .error-page-buttons {
    display: inline-flex;
    flex-direction: row;
    gap: 32px;
  }
}
`
